module.exports = __webpack_public_path__ + "static/img/3.8222dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/3.png
// module id = l5F3
// module chunks = 0